// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"8e5647ce","461":"4f413605","551":"ab881a4a","694":"d6499332","722":"08d4e14b","881":"4c69ff0c"}[chunkId] + ".chunk.css";
};